import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import Header from '../components/header/Header';
import AvatarCanvas from '../components/avatar/AvatarCanvas';

const STEPS = [
  {
    number: '01',
    title: 'Tải ảnh lên',
    desc: 'Chọn ảnh từ máy tính hoặc điện thoại (JPG, PNG, WEBP)',
  },
  {
    number: '02',
    title: 'Chỉnh sửa',
    desc: 'Kéo, phóng to, xoay và lật ảnh để vừa với khung',
  },
  {
    number: '03',
    title: 'Tải về',
    desc: 'Nhấn "Tải Avatar Về Máy" để lưu ảnh 960×960px',
  },
];

export default function AvatarPage() {
  const frameSrc = process.env.PUBLIC_URL + '/frames/avatar-frame.png';

  return (
    <div className="min-h-screen pb-10 relative bg-[#0043D3] bg-no-repeat bg-cover bg-center">
      <Header />

      {/* Hero banner */}
      <Box
        sx={{
          py: { xs: 4, md: 6 },
          px: 2,
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          className="bg-gradient-to-r from-[#FFD942] to-[#FF7E22] bg-clip-text text-transparent"
          sx={{
            fontWeight: 800,
            mb: 1.5,
            fontSize: { xs: '1.8rem', md: '2.5rem' },
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}
        >
          Tạo Avatar Sự Kiện 🎉
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#ffffff',
            opacity: 0.95,
            maxWidth: 580,
            mx: 'auto',
            fontSize: { xs: '0.95rem', md: '1.05rem' },
            lineHeight: 1.6,
          }}
        >
          Upload ảnh của bạn, căn chỉnh trong khung sự kiện HungHau và tải về để dùng
          làm avatar Facebook, Zalo, Teams.
        </Typography>
      </Box>

      <Container maxWidth="lg" sx={{ pb: { xs: 3, md: 5 } }}>
        {/* 3-step guide */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
            gap: 2.5,
            mb: { xs: 3, md: 5 },
          }}
        >
          {STEPS.map((step) => (
            <Paper
              key={step.number}
              elevation={0}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                p: 2.5,
                borderRadius: 3,
                border: '1px solid rgba(255, 255, 255, 0.15)',
                backgroundColor: 'rgba(0, 0, 234, 0.7)',
                backdropFilter: 'blur(8px)',
              }}
            >
              {/* Circle number */}
              <Box
                sx={{
                  minWidth: 42,
                  minHeight: 42,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #f23f0f 0%, #fcc606 100%)',
                  color: '#fff',
                  fontWeight: 800,
                  fontSize: '0.95rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                }}
              >
                {step.number}
              </Box>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 700, mb: 0.5, color: '#ffffff' }}>
                  {step.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  {step.desc}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Box>

        {/* Main editor */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 380px' },
            gap: 3,
            alignItems: 'start',
          }}
        >
          {/* Canvas card */}
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 3,
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backgroundColor: '#ffffff',
              boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#0043D3' }}>
              Chỉnh sửa ảnh
            </Typography>
            <AvatarCanvas frameSrc={frameSrc} />
          </Paper>

          {/* Tips card */}
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 3,
              border: '1px solid #FFC800',
              backgroundColor: 'rgba(0, 20, 242, 0.9)',
              color: '#ffffff',
              boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#FFC800' }}>
              💡 Gợi ý
            </Typography>
            <Box component="ul" sx={{ pl: 2, m: 0 }}>
              {[
                'Dùng ảnh chân dung (vuông hoặc dọc) để kết quả đẹp hơn.',
                'Kéo ảnh để căn chỉnh vị trí khuôn mặt vào khung.',
                'Dùng slider Zoom để phóng to / thu nhỏ ảnh.',
                'Nút căn giữa (⊙) giúp đưa ảnh về trung tâm nhanh.',
                'Trên điện thoại: dùng ngón tay kéo ảnh trong khung.',
                'Ảnh output: PNG 960×960px, sẵn sàng dùng làm avatar.',
              ].map((tip, i) => (
                <Box component="li" key={i} sx={{ mb: 1 }}>
                  <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                    {tip}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Box>
      </Container>
    </div>
  );
}
